import "./../../modules/accordion/assets/scripts/accordion.js";
import "./../../modules/core-columns/assets/scripts/front-end.js";
import "./../../modules/core-image/assets/scripts/front-end.js";
import "./../../modules/core-table/assets/scripts/front-end.js";
import "./../../modules/core-table/assets/vendor/scroll-hint.js";
import "./../../modules/header/node_modules/a11y-dialog/a11y-dialog.js";
import "./../../modules/header/assets/scripts/dropdown-menu-primary.js";
import "./../../modules/header/assets/scripts/mobile-menu.js";
import "./../../modules/header/assets/scripts/header-search.js";
import "./../../modules/hero-slider/assets/scripts/hero-slider.js";
import "./../../modules/lightbox/assets/vendor/tobii/dist/tobii.min.js";
import "./../../modules/lightbox/assets/scripts/lightbox.js";
import "./../../modules/share-buttons/assets/scripts/share-buttons.js";